import { apiClient } from '@/lib/api/client'

/** SOLY-ALERTS-001 — one catalogue alert with its per-organization on/off state. */
export interface AlertSettingDto {
  code: number
  key: string
  family: 'Metre' | 'Commandes' | 'Pose'
  title: string
  severity: 'Hard' | 'Soft'
  enabled: boolean
  isDefault: boolean
}

interface AlertSettingsResponse {
  alerts: AlertSettingDto[]
}

/** The whole alert catalogue with each alert's switch state for the current organization. */
export async function getAlertSettings(): Promise<AlertSettingDto[]> {
  const res = await apiClient.get<AlertSettingsResponse>('/api/planning/alert-settings')
  return res.alerts
}

/** Turn a single alert on/off for the organization (keyed on the stable alert slug). */
export async function setAlertEnabled(key: string, enabled: boolean): Promise<void> {
  await apiClient.put<{ success: boolean }>(`/api/planning/alert-settings/${encodeURIComponent(key)}`, { enabled })
}

export type AlertFamily = AlertSettingDto['family']

export const ALERT_FAMILY_ORDER: AlertFamily[] = ['Metre', 'Commandes', 'Pose']

export const ALERT_FAMILY_LABELS: Record<AlertFamily, string> = {
  Metre: 'Métré',
  Commandes: 'Commandes fournisseurs',
  Pose: 'Pose',
}

/** Group the catalogue by family, in the canonical Métré → Commandes → Pose order (registry order within). */
export function groupAlertsByFamily(alerts: AlertSettingDto[]): { family: AlertFamily; alerts: AlertSettingDto[] }[] {
  return ALERT_FAMILY_ORDER
    .map((family) => ({ family, alerts: alerts.filter((a) => a.family === family) }))
    .filter((group) => group.alerts.length > 0)
}
